<template>
  <div class="p-3 d-flex border-top justify-content-end flex-gap-1">
    <slot />
  </div>
</template>

<script>
export default {
  name: "EgModalFooter",
};
</script>
